import script from "./TraningTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./TraningTabs.vue?vue&type=script&setup=true&lang=js"

import "./TraningTabs.vue?vue&type=style&index=0&id=09f173e4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09f173e4"]])

export default __exports__